import React from 'react'

export function component(): VDOM {
    return <div className="c-promotion" />
}
